import Masonry from 'masonry-layout';
import imagesloaded from 'imagesloaded';

const clients = {
  clientsNode: null,
  containerNode: null,
  moreBtnNode: null,
  loadingNode: null,
  filters: null,
  msnry: null,
  paged: 1,
  maxPages: 1,
  lang: null,
  apiPrefix: null,

  init() {
    this.clientsNode = document.querySelector('.js-clients');

    if(this.clientsNode) {
      this.initLang();
      this.initApiPrefix();

      this.containerNode = this.clientsNode.querySelector('.js-clients-container');
      this.moreBtnNode = this.clientsNode.querySelector('.js-clients-load-more');
      this.loadingNode = this.clientsNode.querySelector('.js-loading');
      this.filters = Array.from(this.clientsNode.querySelectorAll('.js-clients-filters input[type="checkbox"]'));

      this.msnry = new Masonry( this.containerNode, {
        itemSelector: '.js-clients-item',
        horizontalOrder: true,
        percentPosition: true,
        transitionDuration: '0.5s',
        stagger: 30,
      });

      this.initEvents();
      this.fetchItems();
    }
  },

  initEvents() {
    this.moreBtnNode.addEventListener('click', () => {
      this.paged += 1;
      this.fetchItems();
    }, false);

    this.filters.forEach((el) => {
      el.addEventListener('change', (e) => this.handleChangeFilters(e), false);
    });
  },

  initLang() {
    if (document.documentElement.lang !== 'pl-PL') {
      this.lang = 'en';
    }
  },

  initApiPrefix() {
    /* global apiPrefix */
    if (typeof apiPrefix !== 'undefined') {
      this.apiPrefix = apiPrefix;
    }
  },

  clearFilters() {
    this.filters.forEach(el => {
      el.checked = el.value === 'all';
    });
  },

  blockFilters(option = true) {
    this.filters.forEach(el => {
      el.disabled = option;
    });
  },

  isAnyFilterChecked() {
    return !!this.filters.find(el => {
      return el.checked && el.value !== 'all';
    });
  },

  uncheckDefaultFilter() {
    const allFilter = this.filters.find(el => {
      return el.value === 'all';
    });

    if(allFilter) {
      allFilter.checked = false;
    }
  },

  handleChangeFilters(e) {
    const target = e.target;
    const targetValue = target.value;

    if(targetValue === 'all') {
      const isFirstCheck = target.checked;
      this.clearFilters();

      if(!isFirstCheck) return;
    } else {
      this.isAnyFilterChecked() ? this.uncheckDefaultFilter() : this.clearFilters();
    }

    this.removeItems();

    this.paged = 1;
    this.maxPages = 1;

    this.fetchItems();
  },

  removeItems() {
    while (this.containerNode.firstChild) {
      const firstChild = this.containerNode.firstChild;
      this.msnry.remove(firstChild);
      this.containerNode.removeChild(firstChild);
    }

    this.containerNode.style.height = 'auto';
  },

  createSingleItem(item) {
    const { boxTitle, boxDescription, boxImage, categories } = item;

    let catHTML = '';
    if(categories) {
      catHTML = '<div class="border-t border-grey border-solid"><ul class="p-24 -mx-8 -mb-8 text-12 text-grey-dark uppercase">';
      categories.forEach((cat) => {
        catHTML += `<li class="inline-block mx-8 mb-8">#${cat}</li>`;
      });
      catHTML += '</ul></div>';
    }

    const itemWrapper = document.createElement('div');
    itemWrapper.setAttribute('class', 'px-16 w-full sm:w-1/2 xl:w-1/3 mb-32 js-clients-item');

    itemWrapper.insertAdjacentHTML('beforeend',
`<div class="bg-white shadow rounded-20 overflow-hidden border border-grey border-solid">
        <div class="relative block">
          <img src="${boxImage.url}" alt="${boxImage.alt}" class="block w-full">
          <h4 class="absolute bottom-0 left-0 p-24 w-full text-center text-white text-20 overlay">${boxTitle}</h4>
        </div>
        <div class="p-24"><p class="text-14">${boxDescription}</p></div>
        ${catHTML}
      </div>`
    );

    return itemWrapper;
  },

  createItems(items) {
    const boxes = [];
    const df = document.createDocumentFragment();
    items.forEach((item) => {
      const client = this.createSingleItem(item);
      boxes.push(client);
      df.appendChild(client);
    });

    this.containerNode.appendChild(df);
    this.msnry.appended(boxes);
  },

  updateInterface() {
    imagesloaded(this.containerNode, () => {
      this.loadingNode.classList.remove('is-active');
      this.msnry.layout();
      this.blockFilters(false);
    });

    this.moreBtnNode.parentElement.classList[this.paged < this.maxPages ? 'remove' : 'add']('hidden');
  },

  fetchItems() {
    this.blockFilters(true);
    this.loadingNode.classList.add('is-active');
    this.moreBtnNode.parentElement.classList.add('hidden');
    fetch(`${this.apiPrefix ? this.apiPrefix : ''}${this.lang ? '/' + this.lang : ''}/wp-json/wp/v2/clients/${this.paged}${this.getParams()}`)
      .then((resp) => {
        return resp.json();
      })
      .then((resp) => {
        this.maxPages = resp.maxPages;
        if(resp.items) {
          this.createItems(resp.items);
        }
        this.updateInterface();
      });
  },

  getCheckedFilters() {
    let checkedFilters = this.filters.filter(el => {
      return el.checked;
    });

    if (checkedFilters && checkedFilters.length > 0) {
      return checkedFilters;
    }

    return null;
  },

  getParams() {
    let params = '';
    const checkedFilters = this.getCheckedFilters();

    if (checkedFilters) {
      params = '?';
      checkedFilters.forEach((el, index) => {
        params += `${index === 0 ? '' : '&'}sc[]=${el.value}`;
      });
    }

    return params;
  },

};

export default clients;



// WEBPACK FOOTER //
// ./scripts/modules/clients.js